import { observer } from 'mobx-react';
import React from 'react';
import { Instance } from 'mobx-state-tree';
import { IItemRendererProps, Select } from '@blueprintjs/select';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import { Button, MenuItem } from '@blueprintjs/core';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { TranslatedMessage } from '../translation';
import { Group } from '../../../store/models/Group';

interface GroupSelectionProps extends WithTranslateProps {
  groupList: Array<Instance<typeof Group>>;
  onChange?: (group: Instance<typeof Group>) => void;
  selectedGroupName?: string;
  getGroupByName: (name: string) => any;
}

@observer
class GroupSelection extends React.Component<GroupSelectionProps> {
  onSelect = async (value) => {
    if (this.props.onChange !== null && this.props.onChange !== undefined) {
      this.props.onChange!(value!);
    }
  };

  get TypedSelectInput() {
    return Select.ofType<Instance<typeof Group>>();
  }

  renderGroupMenuItem(item: Instance<typeof Group>, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem key={`group-${index}`} active={modifiers.active} onClick={handleClick} text={item.name!} />
      );
    } else {
      return null;
    }
  }

  filterGroup = (query, group) => {
    return group.name!.toLowerCase().indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { selectedGroupName, groupList, getGroupByName } = this.props;
    const selectedGroup = selectedGroupName ? getGroupByName(selectedGroupName) : null;

    const TypedSelectInput = this.TypedSelectInput;
    return (
      <div>
        <TypedSelectInput
          onItemSelect={(item) => {
            this.onSelect(item);
          }}
          items={toJS(groupList)}
          itemRenderer={this.renderGroupMenuItem}
          itemPredicate={this.filterGroup}
          popoverProps={{ minimal: true }}
        >
          <Button
            rightIcon="caret-down"
            text={
              selectedGroup ? selectedGroup.name! : <TranslatedMessage id={TLCode.CHOOSE_A_GROUP} />
            }
          />
        </TypedSelectInput>
      </div>
    );
  }
}

export default withTranslate(GroupSelection);
